import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import React, { forwardRef, useMemo, useState } from 'react';
import { MoreHoriz as MoreHorizIcon } from '@ringcentral/juno-icon';
import { styled, useEventCallback, useId, } from '../../../../foundation';
import { RcIcon } from '../../../Icon';
import { RcListItemIcon, RcListItemText } from '../../../List';
import { RcMenu, RcMenuItem, } from '../../../Menu';
import { RcTooltip } from '../../../Tooltip';
import { RcTab } from '../../Tab';
import { MoreMenuTabStyle } from './styles';
var DEFAULT_MORE_MENU_TAB_LABEL = 'more_menu_tab';
var _MoreMenuTab = forwardRef(function (props, ref) {
    var menuItems = props.menuItems, _a = props.MenuItemComponent, MenuItemComponent = _a === void 0 ? RcMenuItem : _a, _b = props.MenuProps, MenuProps = _b === void 0 ? {} : _b, TooltipProps = props.TooltipProps, onChange = props.onChange, MoreIconProp = props.MoreIcon, rest = __rest(props, ["menuItems", "MenuItemComponent", "MenuProps", "TooltipProps", "onChange", "MoreIcon"]);
    var menuIdProp = MenuProps.id, onMenuCloseProp = MenuProps.onClose, MenuPropsRest = __rest(MenuProps, ["id", "onClose"]);
    var menuId = useId(menuIdProp);
    var _c = __read(useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var open = Boolean(anchorEl);
    var MoreIcon = (function () {
        var Icon;
        if (!MoreIconProp) {
            Icon = (React.createElement(RcIcon, { size: "medium", color: "neutral.f04", symbol: MoreHorizIcon }));
        }
        else if (typeof MoreIconProp === 'function') {
            Icon = MoreIconProp(open);
        }
        else {
            Icon = MoreIconProp;
        }
        if (TooltipProps === null || TooltipProps === void 0 ? void 0 : TooltipProps.title) {
            return React.createElement(RcTooltip, __assign({}, TooltipProps), Icon);
        }
        return Icon;
    })();
    var handleTabClick = useEventCallback(function (event) {
        setAnchorEl(event.currentTarget);
    });
    var handleMenuClose = useEventCallback(function (event, reason) {
        setAnchorEl(null);
        onMenuCloseProp === null || onMenuCloseProp === void 0 ? void 0 : onMenuCloseProp(event, reason);
    });
    var MenuList = useMemo(function () {
        if (!menuItems || menuItems.length === 0) {
            return null;
        }
        return menuItems.map(function (item) {
            var icon = item.icon, label = item.label, value = item.value, disabled = item.disabled, onClick = item.onClick, selected = item.selected, key = item.key, menuItemRest = __rest(item, ["icon", "label", "value", "disabled", "onClick", "selected", "key"]);
            var handleClick = function (event) {
                onChange === null || onChange === void 0 ? void 0 : onChange(event, value);
                onClick === null || onClick === void 0 ? void 0 : onClick(event);
            };
            return (React.createElement(MenuItemComponent, { key: key, disabled: disabled, selected: selected, value: value, onClick: handleClick, "data-test-automation-id": menuItemRest['data-test-automation-id'] },
                icon ? React.createElement(RcListItemIcon, null, icon) : null,
                React.createElement(RcListItemText, { primary: label || value })));
        });
    }, [MenuItemComponent, menuItems, onChange]);
    return (React.createElement(React.Fragment, null,
        React.createElement(RcTab, __assign({}, rest, { ref: ref, onClick: handleTabClick, label: MoreIcon, value: DEFAULT_MORE_MENU_TAB_LABEL, "aria-haspopup": "true", "aria-controls": menuId, "data-tab-more-button": "" })),
        React.createElement(RcMenu, __assign({ autoClose: true }, MenuPropsRest, { id: menuId, anchorEl: anchorEl, open: open, variant: "menu", onClose: handleMenuClose }), MenuList)));
});
/** inner component */
var MoreMenuTab = styled(_MoreMenuTab)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), MoreMenuTabStyle);
MoreMenuTab.defaultProps = {
    label: DEFAULT_MORE_MENU_TAB_LABEL,
    value: DEFAULT_MORE_MENU_TAB_LABEL,
};
MoreMenuTab.displayName = 'MoreMenuTab';
export { DEFAULT_MORE_MENU_TAB_LABEL, MoreMenuTab };
var templateObject_1;
